"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectBase = _interopRequireDefault(require("./select-base"));
var _selectStateWrapper = _interopRequireDefault(require("./select-state-wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * A `select` component that leverages the browser's built in `select`, layering
 * on a styled label and presentation for the currently selected option.
 */
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  // If a value is not passed as a prop, use component state to manage the value.
  // The result either way is a controlled component where React is in control of
  // the value.
  // https://react.dev/reference/react-dom/components/select#controlling-a-select-box-with-a-state-variable
  var Component = props.value === undefined ? _selectStateWrapper["default"] : _selectBase["default"];
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    ref: ref
  }, props));
});
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `option` elements associated with the `select` element.
   */
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  /**
   * A flag indicating that the field uses a custom element to display field status
   * and should not wrap error messages in a `FieldStatus` component.
   */
  customFieldStatus: _propTypes["default"].bool,
  /**
   * A flag indicating that the field should display its error message irrespective of the field's
   * error status. If set to `true`, the error message will display no matter what. If set to
   * `false`, it will never display.
   */
  displayStatus: _propTypes["default"].bool,
  /**
   * A flag passed to the underlying FieldBase component. If your Select does not
   * need an error message, pass "false" here to save some unneeded DOM from being rendered.
   */
  enableValidationMessage: _propTypes["default"].bool,
  /**
   * A flag indicating that the field is in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * A message to display when the field is in an error state. Wrapped in a `FieldStatus` component
   * by default.
   */
  errorMessage: _propTypes["default"].node,
  /**
   * Set to true to hide float label text from screen readers
   */
  floatLabelAriaHidden: _propTypes["default"].bool,
  /**
   * Flag that hides placeholder in the dropdown.
   */
  hidePlaceholderOption: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  /**
   * Set to true to display select as greyed out and recessed.
   */
  useInactiveStyle: _propTypes["default"].bool,
  /**
   * Becomes the float label in the associated field base
   */
  label: _propTypes["default"].string.isRequired,
  /**
   * For use cases where a select has a default option pre-selected, use this
   * prop to visually indicate that the user chose something else
   */
  modified: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  /**
   * An optional label to be used as a hint or reminder when a selection has been
   * made, this is used in starbucks.com product detail pages to denote when a product
   * option is not the default.
   */
  secondaryLabel: _propTypes["default"].string,
  /**
   * A function allowing the select component's getSelectedOption to pass a custom
   * text for the selected option. Returns custom text.
   */
  selectedOptionFormatter: _propTypes["default"].func,
  value: _propTypes["default"].string,
  /**
   * A string that sets the styling to match a preset. Currently only `green` is supported.
   * See example for more details
   */
  visualStyle: _propTypes["default"].string
} : {};
Select.displayName = 'Select';
var _default = exports["default"] = Select;